import React from 'react';
import ReactDOM from 'react-dom';
import InteractiveHomeTool from './interactive-home-tool/InteractiveHomeTool/InteractiveHomeTool';
import '../scss/interactive-home-tool.scss';

const App = () => <InteractiveHomeTool />;

ReactDOM.render(<App />, document.getElementById('interactive-home-tool'));